module.exports = __webpack_public_path__ + "static/media/markflix.e791e370.png";